import { TemplateMeta } from '@anm/api/modules/templates';

import { EditButtonProps } from './types';

type RatioNameProps = EditButtonProps & {
  meta?: TemplateMeta;
  aspects?: string | null;
};

export const getRatioFormatName = ({ aspects, currentRatioFormat, meta = {} as TemplateMeta }: RatioNameProps) => {
  const mediaKeys = Object.keys(meta.media);

  const ratioFormatFromSelectedAspectRatio = mediaKeys.reduce((acc, item) => {
    if (aspects?.includes(item)) {
      return item;
    }
    return acc;
  }, meta.defaultTarget);

  return currentRatioFormat?.name || ratioFormatFromSelectedAspectRatio;
};

export const getTemplateId = (id?: string) => id?.split('-')[0];
